/** @format */

import { push } from 'connected-react-router';
import { listAllOwnerOnboardingRequestsApiService } from 'services/apiService';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actionTypes from 'stateContainer/action-types';

function* workerSaga({ payload, statusType }) {
  try {
    const response = yield call(
      listAllOwnerOnboardingRequestsApiService,
      statusType,
      payload
    );
    if (response.data.status == 'success') {
      /**
       * finally conclude the list action
       */

      yield put({
        type: actionTypes.All_OWNER_OWNBOARD_LIST_SUCCESS,
        data: response.data.data,
        paging: response.data.pagination
      });
    } else {
      throw new Error('Data fetch failed');
    }
  } catch (error) {
    if (error.response.data.error == 'NotAuthorized') {
      yield put(push({ type: actionTypes.LOGOUT_REQUESTED }));
      yield put(push('/login'));
    }
    yield put({ type: actionTypes.All_OWNER_OWNBOARD_LIST_FAILED, error });
  }
}

export function* fetchAllOwnerOnboardDataSaga() {
  yield takeLatest(actionTypes.All_OWNER_OWNBOARD_LIST_REQUESTED, workerSaga);
}
